import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { getLearningPaths } from "../../../api/endpoints/LearningPathEndpoints";
import { LearningPath } from "../../../models/LearningPath";
import { Paged } from "../../../models/Paged";

export default function useGetLearningPathsPaginated() {
  return useMutation<Paged<LearningPath>, AxiosError, { page: number }>({
    mutationKey: ["learning-paths"],
    mutationFn: ({ page }) => getLearningPaths(page),
  });
}
